import { baseApiUrl, fetcher, handleError, ServerErrorResponse } from 'data_sources/constants';
import { OrganizationAccreditationConfig, UpdateOrganizationAccreditationConfigObject } from '../../../_types/accreditation';

export const updateOrganizationAccreditationConfig = async (
  orgId: string,
  config: UpdateOrganizationAccreditationConfigObject,
  callback?: (data: OrganizationAccreditationConfig) => void,
  onError?: (errors: ServerErrorResponse) => void
): Promise<OrganizationAccreditationConfig> => {
  if (!orgId) throw new Error('No organization ID provided.');
  
  const url = `${baseApiUrl()}/admin-solution/v1/organizations/${orgId}/solutions/awb/config`;
  
  try {
    const response = await fetcher({
      method: 'PUT',
      url,
      body: config,
    });
    
    if (callback) callback(response);
    return response;
  } catch (err: any) {
    if (onError) handleError(err, { onError });
    throw err;
  }
};
